import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  BannersCarousel,
  WalletActionButtons,
  WalletAssetsList,
  WalletBalanceBlock,
  WalletCardsSection,
  WalletTopBar,
  WalletTransactionsSection,
} from "../../components/pages/wallet";
import { useTelegram, useDesktopLayout } from "../../hooks";
import { v } from "../../utils/runtime";

export function Home() {
  const theme = useTheme();
  const { tg } = useTelegram();
  const isDesktop = useDesktopLayout();
  const isMobile =
    tg.platform !== "tdesktop" &&
    tg.platform !== "weba" &&
    tg.platform !== "macos";

  return (
    <>
      {/* Фон-градиент. На десктопе живёт в RootLayout — общий для всех
          страниц, здесь только мобильная полоса под верхом. */}
      {!isDesktop && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            width: "100%",
            height: "100%",
            maxHeight: "280px",
            backgroundImage:
              theme.palette.mode === "dark"
                ? `url('${v("/dark-theme-gradient.jpg")}')`
                : `url('${v("/light-theme-gradient.jpg")}')`,
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% auto",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />
      )}

      {isDesktop ? (
        // --------------------------- DESKTOP ---------------------------
        // Двухколоночный layout:
        //   • слева (sticky, ~360px): баланс, кнопки действий, карты;
        //   • справа (гибкая ширина): баннеры, список активов, история.
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            width: "100%",
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "minmax(320px, 360px) minmax(0, 1fr)",
            },
            gap: "24px",
            alignItems: "start",
          }}
        >
          {/* Левая колонка: sticky, чтобы баланс/кнопки всегда были на виду */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              position: "sticky",
              top: 24,
            }}
          >
            <WalletTopBar />
            <WalletBalanceBlock />
            <WalletActionButtons />
            <WalletCardsSection />
          </Box>

          {/* Правая колонка: основной поток контента.
              Баннеры → активы → последние транзакции. */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              minWidth: 0,
            }}
          >
            <BannersCarousel />
            <WalletAssetsList />
            <WalletTransactionsSection />
          </Box>
        </Box>
      ) : (
        // --------------------------- MOBILE / TG ---------------------------
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            display: "grid",
            gap: "24px",
            width: "100%",
            marginTop: isMobile ? "12px" : "8px",
            marginBottom: "120px",
          }}
        >
          <WalletTopBar />
          <WalletBalanceBlock />
          <WalletActionButtons />
          <BannersCarousel />
          <WalletAssetsList />
          <WalletCardsSection />
          <WalletTransactionsSection />
        </Box>
      )}
    </>
  );
}
